export default __webpack_public_path__ + "static/media/logo.ebc5b49c.svg";